import { BillDetails } from "../../../services/billService/BillService.type";

export const BillsListContents = {
  labels: {
    id: "Id",
    challanId: "Challan Id",
    updatedOn: "Updated On",
    type: "Type",
    challanAmount: "Amount (in Rs)",
    status: "Status",
    remark: "Remark",
    receipt: "Receipt",
    gst: "GST",
    heading: "Bill List"
  },
  placeHolders: {
    filter: "Filter By Status"
  }
};

export interface BillListType extends BillDetails {
  type: string;
}
